import AuditListing from "./AuditListing";
import AuditHeader from "./AuditHeader";
export {
    AuditListing,
    AuditHeader
}
export const fisAuditFilters = {
    'action_type': {
        'inputType': 'dropdown',
        'title': 'Action Type',
        'options': [{ label: "SPARTA_TO_FIS", value: "1" }, { label: "FIS_TO_SPARTA", value: "2" }],
        'labelKey': 'label',
        'valueKey': 'label',
    },
    'status': {
        'inputType': 'dropdown',
        'title': 'Status',
        'options': [{ label: "SUCCESS", value: "1" }, { label: "FAILED", value: "2" }],
        'labelKey': 'label',
        'valueKey': 'label',
    },
    // 'from': {
    //     'inputType': 'date',
    //     'title': 'From Date',
    // },
    // 'to': {
    //     'inputType': 'date',
    //     'title': 'To Date',
    // },

}